import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { installChunkReloadHandler } from './utils/chunkReload'
import { DESIGN_SYSTEM_HARNESS_PATH } from './components/common'

installChunkReloadHandler()

const root = createRoot(document.getElementById('root'))
const renderApp = (content) => root.render(<StrictMode>{content}</StrictMode>)

if (import.meta.env.DEV && window.location.pathname === DESIGN_SYSTEM_HARNESS_PATH) {
  import('./components/common/DesignSystemHarness').then(({ DesignSystemHarness }) => {
    renderApp(<DesignSystemHarness />)
  })
} else {
  renderApp(<App />)
}
